import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { environment } from '../../../environments/environment';
import { AuthenticationService } from '../../core/services/authentication.service';
import { TranslatePipe } from '@ngx-translate/core';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'login-page',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    NgOptimizedImage,
    TranslatePipe,
    MatButton,
  ],
  templateUrl: './login-page.component.html',
})
export class LoginPageComponent {
  private readonly authenticationService = inject(AuthenticationService);

  public signIn(): void {
    this.authenticationService.signIn();
  }

  public signInWithSpid(): void {
    this.authenticationService.signInWithSpid();
  }

}
